// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__gGlid","cell":"ColumnAccessor_cell__3DGNP","firstCellAccent":"ColumnAccessor_firstCellAccent__3z_M7"};